export const DELIVERY_IS_UNAVAILABLE = 'deliveryIsUnavailable.th';

export const NO_RESTAURANT_DELIVERY_CTA = 'noRestaurantDeliveryCta.th';

export default {
  hasShowMeDealsButton: false,
  hasDeliveryPartnersButton: true,
};
